import i18n from './I18nUtil'

/**
 * This simulates a passwords strength for the choosen passwords pattern
 *
 * @param state object
 * @returns {object}
 */
const getPasswordStrengthParameters = (state) => {
    const {
        allowLowercaseLetters,
        allowUppercaseLetters,
        allowNumbers,
        allowSpecialCharacters,
        allowZeros,
        allowUmlauts,
        easyToRemember,
        passwordLength,
    } = state

    let passwordStrengthColor = '#74c974'
    let passwordStrengthLevel = 'Website-Level'
    let iconName = 'okShield'
    if (Number(passwordLength) >= 52) {
        passwordStrengthLevel = 'Bigbang-Level'
    } else if (Number(passwordLength) >= 32 && Number(passwordLength) < 52) {
        passwordStrengthLevel = 'Fort-Knox-Level'
    } else if (Number(passwordLength) >= 16 && Number(passwordLength) < 32) {
        passwordStrengthLevel = 'Server-Level'
    } else if (Number(passwordLength) >= 8 && Number(passwordLength) < 16) {
        passwordStrengthColor = '#ffae00'
        iconName = 'flagShield'
    } else if (Number(passwordLength) < 8) {
        passwordStrengthColor = '#fe3333'
        iconName = 'flagShield'
    }

    // don't let the number get too high, so we just add decimals after 16
    let length = passwordLength > 18 ? parseFloat('18.' + passwordLength) : passwordLength
    let baseNumber = 0.5

    if (allowUppercaseLetters) {
        baseNumber += 3
    }
    if (allowLowercaseLetters) {
        baseNumber += 3
    }
    if (allowNumbers) {
        baseNumber += 1
    }
    if (allowSpecialCharacters) {
        baseNumber += 2
    }
    if (allowZeros) {
        baseNumber += 0.5
    }
    if (allowUmlauts) {
        baseNumber += 0.5
    }
    if (easyToRemember) {
        baseNumber = 3.5
    }

    let expectedTime = Math.pow(baseNumber, length)
    let result = Math.round((expectedTime /  60 / 60 / 24 / 365))
    let measurementUnit = result > 1 ? i18n('measurement_unit.time.years') : i18n('measurement_unit.time.year')
    if (result <= 0) {
        result = Math.round((expectedTime /  60 / 60 / 24 / 30))
        measurementUnit = result > 1 ? i18n('measurement_unit.time.months') : i18n('measurement_unit.time.month')
    }
    if (result <= 0) {
        result = Math.round((expectedTime /  60 / 60 / 24))
        measurementUnit = result > 1 ? i18n('measurement_unit.time.days') : i18n('measurement_unit.time.day')
    }
    if (result <= 0) {
        result = Math.round((expectedTime /  60 / 60))
        measurementUnit = result > 1 ? i18n('measurement_unit.time.hours') : i18n('measurement_unit.time.hour')
    }
    if (result <= 0) {
        result = Math.round((expectedTime /  60))
        measurementUnit = result > 1 ? i18n('measurement_unit.time.minutes') : i18n('measurement_unit.time.minute')
    }
    if (result <= 0) {
        result = Math.round((expectedTime))
        measurementUnit = result > 1 ? i18n('measurement_unit.time.seconds') : i18n('measurement_unit.time.second')
    }

    return {
        time: result.toLocaleString('de-DE') + ' ' + measurementUnit,
        level: passwordStrengthLevel,
        color: passwordStrengthColor,
        icon: iconName,
    }
}

export default getPasswordStrengthParameters



// WEBPACK FOOTER //
// ./src/jsx/Utils/PasswordStrengthUtil.jsx